export const FRESHDESK_ENCRYPTED_DOMAIN = "=02bj5yazVGZoNXZyZmLwxWZo1ibldGdzlGb";
export const FRESHDESK_ENCRYPTED_API_KEY = "=ElMIFUeTl1TvxkcS52MXVlT";

export const FRESHDESK_TICKET_STATUS = 2;
export const FRESHDESK_TICKET_PRIORITY = 1;
export const FRESHDESK_TICKET_SOURCE = 2;

export const FRESHDESK_TICKETS_API_PATH = "/api/v2/tickets";
export const FRESHDESK_SUPPORT_BASE_URL = "https://listgen-help.freshdesk.com";
